import { useIsMobileApp } from './useIsMobileApp.ts';

export const useIsAuthorizedRouteForSecondFactorRecommendation = () => {
  const { isIosApp } = useIsMobileApp();

  return !isIosApp;
};
